export const mapGeography = {
  states: "state",
  dma: "dma",
} as const;

export type MapGeography = (typeof mapGeography)[keyof typeof mapGeography];
